import { AppActionType } from '../types'

export const updateCurrentAct = (act) => {
  return {
    type: AppActionType.UPDATE_CURRENT_ACT,
    payload: act
  }
}

export const updateNetworkSpeed = (speed) => {
  return {
    type: AppActionType.UPDATE_NETWORK_SPEED,
    payload: speed
  }
}

export const setMenu = (open = false) => {
  return {
    type: AppActionType.SET_MENU,
    payload: open
  }
}

export const setMenuContent = (content =  null) => {
  return {
    type: AppActionType.SET_MENU_CONTENT,
    payload: content
  }
}

export const setVideo = (condition =  false, content = null) => {
  return {
    type: AppActionType.SET_VIDEO,
    payload: {condition, content}
  }
}

export const updateLanguage = (language) => ({ type: AppActionType.UPDATE_LANGUAGE, payload: language })

export const setInfo = (condition =  false, content = null, type = "info") => {
  return {
    type: AppActionType.SET_INFO,
    payload: {condition, content, type}
  }
}

export const updateCurrentSong = (song) => {
  return {
    type: AppActionType.UPDATE_CURRENT_SONG,
    payload: song
  }
}

export const updateMuted = (muted = null) => {
  return {
    type: AppActionType.UPDATE_MUTED,
    payload: muted
  }
}

export const updateCurrentSite = (currentSite = null) => {
  return {
    type: AppActionType.UPDATE_CURRENT_SITE,
    payload: currentSite
  }
}

export const setCurrentGama = (content =  null) => {
  return {
    type: AppActionType.SET_CURRENT_GAMA,
    payload: content
  }
}

export const setCurrentCollection = (content =  null) => {
  return {
    type: AppActionType.SET_CURRENT_COLLECTION,
    payload: content
  }
}

export const setCurrentStep = (content =  "gama") => {
  return {
    type: AppActionType.SET_CURRENT_STEP,
    payload: content
  }
}

export const setCurrentMap = (content = null) => {
  return {
    type: AppActionType.SET_CURRENT_MAP,
    payload: content
  }
}
